import api from '../api';
import { API_URL } from '../config';

/**
 * Fetch all employees who share the same projectName as the logged-in PM.
 * Backend endpoint: GET /api/employees/my-team
 * Falls back to filtering getAllEmployees by projectName client-side if the
 * dedicated endpoint is not yet available.
 */
export const getMyTeam = async () => {
  try {
    const response = await api.get(`${API_URL}/employees/my-team`);
    return response.data;
  } catch (error) {
    // If the dedicated endpoint doesn't exist yet (404/403), fall back to
    // filtering all employees by the PM's managed projects
    // if (error.response?.status === 404 || error.response?.status === 405) {
    //   const mainProject = localStorage.getItem('userProjectName') || '';
    //   const secondProject = localStorage.getItem('userSecondProjectName') || '';
    //   const currentEmployeeId = localStorage.getItem('employeeId');

    //   const isValidProject = (name) => {
    //     if (!name || !name.trim()) return false;
    //     const lower = name.trim().toLowerCase();
    //     return lower !== 'n/a' && lower !== 'na' && lower !== 'not applicable' && lower !== '-';
    //   };

    //   // Build the full set of projects the PM manages (skip N/A sentinels)
    //   const managedProjects = new Set();
    //   if (isValidProject(mainProject)) managedProjects.add(mainProject.trim());
    //   if (secondProject) {
    //     secondProject.split('-').forEach((p) => {
    //       const t = p.trim();
    //       if (isValidProject(t)) managedProjects.add(t);
    //     });
    //   }

    //   if (managedProjects.size === 0) return [];

    //   const all = await api.get('/offboarding/employees');
    //   return (all.data || []).filter((emp) => {
    //     // Exclude the PM themselves
    //     if (currentEmployeeId && (emp.employeeId === currentEmployeeId || emp.id === currentEmployeeId)) return false;
        
    //     // Check new projects array
    //     const empProjects = (emp.projects || []).map(p => typeof p === 'string' ? p : p.projectName);
    //     if (empProjects.some(p => managedProjects.has(p))) return true;

    //     // Fallback to old fields
    //     const ep = emp.projectName?.trim();
    //     if (ep && isValidProject(ep) && managedProjects.has(ep)) return true;
    //     const esp = emp.secondProjectName;
    //     if (esp) {
    //       return esp.split('-').some((p) => {
    //         const t = p.trim();
    //         return isValidProject(t) && managedProjects.has(t);
    //       });
    //     }
    //     return false;
    //   });
    // }
    console.error('Error fetching team:', error);
    throw error;
  }
};

/**
 * Fetch basic profile info for a single team member.
 * Reuses the existing /employees/{id} endpoint.
 */
export const getTeamMemberById = async (employeeId) => {
  const response = await api.get(`/employees/${employeeId}`);
  return response.data;
};

/**
 * Fetch the profile image for a team member.
 */
export const getTeamMemberImage = async (employeeId) => {
  try {
    const response = await api.get(`/employees/image/${employeeId}`, {
      responseType: 'blob',
    });
    if (response.data instanceof Blob && response.data.type.startsWith('image/')) {
      return URL.createObjectURL(response.data);
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Fetch all feedback/notes for a team member.
 * Uses the dedicated PM endpoint: GET /api/pm/notes/employee/{id}
 */
export const getTeamMemberFeedbacks = async (employeeId) => {
  const response = await api.get(`${API_URL}/pm/notes/employee/${employeeId}`);
  return response.data;
};

/**
 * Submit a new feedback/note for a team member.
 * Uses the dedicated PM endpoint: POST /api/pm/notes/employee/{id}
 */
export const addTeamMemberFeedback = async (employeeId, noteData) => {
  const response = await api.post(`${API_URL}/pm/notes/employee/${employeeId}`, noteData);
  return response.data;
};

/**
 * Delete a feedback/note by id.
 * Uses the dedicated PM endpoint: DELETE /api/pm/notes/{noteId}
 */
export const deleteTeamMemberFeedback = async (noteId) => {
  const response = await api.delete(`${API_URL}/pm/notes/${noteId}`);
  return response.data;
};

/**
 * Update an existing feedback/note.
 * Uses the dedicated PM endpoint: PUT /api/pm/notes/{noteId}
 */
export const updateTeamMemberFeedback = async (noteId, noteData) => {
  const response = await api.put(`${API_URL}/pm/notes/${noteId}`, noteData);
  return response.data;
};

/**
 * Helper: is the currently logged-in user a Project Manager?
 * A PM is an EMPLOYEE, MANAGER, or HR whose position is "Project Manager".
 */
export const isProjectManager = () => {
  const role = localStorage.getItem('userRole');
  const position = localStorage.getItem('userPosition');
  return ['EMPLOYEE', 'MANAGER', 'HR'].includes(role) && position === 'Project Manager';
};

/**
 * Fetch all projects from the backend.
 */
export const getAllProjects = async () => {
  const response = await api.get('/projects');
  return response.data;
};

/**
 * Assign a manager to a project.
 */
export const assignProjectManager = async (projectId, employeeId) => {
  const response = await api.put(`/projects/${projectId}/manager/${employeeId}`);
  return response.data;
};
